<template>
  <div
    class="bx--grid"
    :class="{
      'bx--grid--condensed': condensed,
      'bx--grid--full-width': fullwidth,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  condensed?: boolean;
  fullwidth?: boolean;
}

const { condensed = false, fullwidth = false } = defineProps<Props>();
</script>
